import { createRouter, createWebHistory } from 'vue-router'
import ChatView from '../views/ChatView.vue'
import HomeView from '../views/HomeView.vue'
import DatasetManager from '../views/DatasetManager.vue'
import DashboardView from '../views/DashboardView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/:widgetId/chat',
    name: 'chat',
    component: ChatView
  },
  {
    path: '/datasets/:widgetId/manage',
    name: 'dataset',
    props: true,
    component: DatasetManager
  },
  {
    path: '/dashboard/:widgetId',
    name: 'dashboard',
    component: DashboardView,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router